
export const name = "feedback-web-renderer-ui";
export const version = "dev";
